import { SellerLocation } from './loi-form';
import { TermFormLocation } from './term-form';

export function effectiveLeaseAssumption(
    leaseAssumption: TermFormLocation['leaseAssumption'] | undefined,
    sellerLocation: SellerLocation | undefined
): TermFormLocation['leaseAssumption'] {
    if (leaseAssumption === 'purchase' && !sellerLocation?.isPropertyPurchaseAvailable) return null;
    return leaseAssumption ?? null;
}
